import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const Section5 = () => {
  return (
    <div>

    <div className='lg:w-[90%] mx-auto font-gilroy py-20 flex md:flex-row flex-col justify-start gap-5 lg:gap-10 '> 
    <div className='md:w-[40%] mx-auto relative overflow-hidden flex justify-center items-center'>
        <div className='w-full h-full absolute top-0 '>
            <div className='w-44 mx-auto h-10 absolute top-0 left-0 right-0 opacity-60 bg-[#727272] rounded-full '></div>
            <div className=' w-20 h-16 absolute top-10 -right-10 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className=' w-7 h-24 absolute top-16 -left-3 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className='w-44 mx-auto h-10 absolute bottom-0 left-0 right-0 opacity-60 bg-[#3055E3] rounded-full '></div>
        </div>
         <div className='w-full h-full flex justify-center items-center bg-[#8989890D] border border-white/5 rounded-2xl backdrop-blur-3xl p-5 '>
        <img src="../assets/gamecontroller.png" className="md:w-9/12 w-6/12" />
        </div> 
        </div>

        <div className=' md:w-[50%] mx-auto '>
        <div className=' mt-3 flex flex-col justify-start items-start'>
            <p className=' md:text-6xl text-4xl font-medium  ' style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #FFFFFF, #FFFFFF,#FFFFFF)",
            WebkitBackgroundClip: "text",
          }}>Complete The 
            </p>
            <div className='flex items-end'>
            <p className='mt-2 md:text-6xl text-4xl font-medium '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #FFFFFF,#FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Tasks</p>
            
          </div>
          <p className='mt-2 text-2xl font-medium '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #FFFFFF,#FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Play Daily. Earn More.</p>
        </div>

        <div className=' mt-5 w-[90%] '>
            <p className=' leading-7 font-light text-sm '>Skilleareum makes learning AI fun, rewarding, and part of your everyday routine. Inside our Telegram Mini App, it’s all about showing up daily and unlocking real value while sharpening your skills. Here’s what’s waiting for you: <span className=' font-semibold '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Spin to Win,</span>
          <span className=' font-semibold '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Missing Letters,</span> <span className=' font-semibold '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Jumble Letters,</span> <span className=' font-semibold '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Perfect Match,</span><span className=' font-semibold '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}> Memory Game </span></p>

             <div className=' mt-5 '>
             <a href="/home" target="_blank">      <button className=' font-semibold text-sm flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-[#0285FF] to-[#1EEF32] rounded-full '>
                        Explore Now<span className=' w-5 h-5 border border-white rounded-full flex justify-center items-center -rotate-45 text-sm '><FontAwesomeIcon icon={faArrowRight} size='sm' /></span>
                        </button></a>
                    </div>
        </div>
        </div>
    </div>

    <div className='lg:w-[90%] mx-auto font-gilroy py-20 flex flex-col md:flex-row-reverse justify-start gap-5 lg:gap-10 '> 
    <div data-aos="fade-right" data-aos-duration="2000" className='md:w-[40%] mx-auto relative overflow-hidden flex justify-center items-center'>
        <div className='w-full h-full absolute top-0 '>
            <div className='w-44 mx-auto h-10 absolute top-0 left-0 right-0 opacity-60 bg-[#727272] rounded-full '></div>
            <div className=' w-20 h-16 absolute top-10 -right-10 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className=' w-7 h-24 absolute top-16 -left-3 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className='w-44 mx-auto h-10 absolute bottom-0 left-0 right-0 opacity-60 bg-[#3055E3] rounded-full '></div>
        
        </div>
         <div className='w-full h-full flex justify-center items-center bg-[#8989890D] border border-white/5 rounded-2xl backdrop-blur-3xl p-5 '>
        <img src="https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/aimage.svg" className="md:w-9/12 w-6/12" />
        </div> 
        </div>

        <div data-aos="fade-up" data-aos-duration="2000" className=' md:w-[50%] mx-auto '>
        <div className=' mt-7 flex flex-col justify-start items-start'>
            <p className=' md:text-6xl text-4xl font-medium  ' style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #FFFFFF, #FFFFFF,#FFFFFF)",
            WebkitBackgroundClip: "text",
          }}>Develop Your  
            </p>
            <p className='mt-2 md:text-6xl text-4xl font-medium '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #FFFFFF,#FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Skills</p>
        </div>

        <div className=' mt-5 w-[90%] '>
            <p className=' leading-7 font-light text-sm '>At Skilleareum, skill-building isn’t just an option — it’s part of your daily journey. Through engaging challenges, hands-on tasks, and personalized learning paths, you’ll level up your AI knowledge one day at a time. 

From mastering AI Facts to completing Daily Skill Quests and exploring practical tools in AI Space, every step is designed to help you grow smarter, faster, and stronger in the world of AI — no coding needed.  </p>

             <div className=' mt-5 '>
             <a href="/home" target="_blank">   <button className=' font-semibold text-sm flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-[#0285FF] to-[#1EEF32] rounded-full '>
                        Develop Skills<span className=' w-5 h-5 border border-white rounded-full flex justify-center items-center -rotate-45 text-sm '><FontAwesomeIcon icon={faArrowRight} size='sm' /></span>
                        </button></a>
                    </div>
        </div>
        </div>
    </div>

    <div className='lg:w-[90%] mx-auto font-gilroy py-20 flex md:flex-row flex-col justify-start gap-5 lg:gap-10 '> 
    <div data-aos="fade-right" data-aos-duration="2000" className='md:w-[40%] mx-auto relative overflow-hidden flex justify-center items-center'>
        <div className='w-full h-full absolute top-0 '>
            <div className='w-44 mx-auto h-10 absolute top-0 left-0 right-0 opacity-60 bg-[#727272] rounded-full '></div>
            <div className=' w-20 h-16 absolute top-10 -right-10 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className=' w-7 h-24 absolute top-16 -left-3 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className='w-44 mx-auto h-10 absolute bottom-0 left-0 right-0 opacity-60 bg-[#3055E3] rounded-full '></div>
        
        </div>
         <div className='w-full h-full flex justify-center items-center bg-[#8989890D] border border-white/5 rounded-2xl backdrop-blur-3xl p-5 '>
        <img src="https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/premiumtrophy.svg" className="" />
        </div> 
        </div>

        <div data-aos="fade-up" data-aos-duration="2000" className=' md:w-[50%] mx-auto '>
        <div className=' mt-3 flex flex-col justify-start items-start'>
            <p className=' md:text-6xl text-4xl font-medium  ' style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #FFFFFF, #FFFFFF,#FFFFFF)",
            WebkitBackgroundClip: "text",
          }}>Unlock Real-Time   
            </p>
            <p className='mt-2 md:text-6xl text-4xl font-medium '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #FFFFFF,#FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Rewards</p>
        </div>

        <div className=' mt-5 w-[90%] '>
            <p className=' leading-7 font-light text-sm '>Every action is an opportunity and watch your efforts turn into real crypto rewards.   

As you develop your skills, you’re earning real Skill Points, unlocking crypto rewards, and turning your dedication into SKLRM tokens that hold value far beyond the platform. Also climb the leaderboard, participate in exclusive contests and events to unlock bonus rewards. The more active you are, the more you earn — it’s that simple.  </p>

             <div className=' mt-5 '>
             <a href="/home" target="_blank">     <button className=' font-semibold text-sm flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-[#0285FF] to-[#1EEF32] rounded-full '>
                        Earn Rewards<span className=' w-5 h-5 border border-white rounded-full flex justify-center items-center -rotate-45 text-sm '><FontAwesomeIcon icon={faArrowRight} size='sm' /></span>
                        </button></a>
                    </div>
        </div>
        </div>
    </div>

    <div className='lg:w-[90%] mx-auto font-gilroy py-20 flex flex-col md:flex-row-reverse justify-start gap-5 lg:gap-10 '> 
    <div data-aos="fade-right" data-aos-duration="2000" className='md:w-[40%] mx-auto relative overflow-hidden flex justify-center items-center'>
        <div className='w-full h-full absolute top-0 '>
            <div className='w-44 mx-auto h-10 absolute top-0 left-0 right-0 opacity-60 bg-[#727272] rounded-full '></div>
            <div className=' w-20 h-16 absolute top-10 -right-10 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className=' w-7 h-24 absolute top-16 -left-3 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className='w-44 mx-auto h-10 absolute bottom-0 left-0 right-0 opacity-60 bg-[#3055E3] rounded-full '></div>
        
        </div>
         <div className='w-full h-full flex justify-center items-center bg-[#8989890D] border border-white/5 rounded-2xl backdrop-blur-3xl '>
        <img src="https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/handshake.svg" className="" />
        </div> 
        </div>

        <div data-aos="fade-up" data-aos-duration="2000" className=' md:w-[50%] mx-auto '>
        <div className=' mt-3 flex flex-col justify-start items-start'>
            <p className=' text-4xl md:text-6xl font-medium  ' style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #FFFFFF, #FFFFFF,#FFFFFF)",
            WebkitBackgroundClip: "text",
          }}>Refer Friends & </p>
            <p className='mt-2 text-4xl md:text-6xl font-medium '  style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #FFFFFF,#FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}>Family</p>
        </div>

        <div className=' mt-5 w-[90%] '>
            <p className=' leading-7 font-light text-sm '>Skilleareum, your growth doesn’t just benefit you — it pays you. Invite your friends with your unique referral link from the mini-app, grow the community, and watch your USDT rewards drop instantly through our real-time referral system along with bonus Skill Points!  

This is more than sharing. It’s about building a community where everyone earns, and you get rewarded instantly for making it happen. </p>

             <div className=' mt-5 '>
             <a href="/home" target="_blank">   <button className=' font-semibold text-sm flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-[#0285FF] to-[#1EEF32] rounded-full '>
                        Refer Friend<span className=' w-5 h-5 border border-white rounded-full flex justify-center items-center -rotate-45 text-sm '><FontAwesomeIcon icon={faArrowRight} size='sm' /></span>
                        </button></a>
                    </div>
        </div>
        </div>
    </div>

    </div>
  )
}

export default Section5